// extracted by mini-css-extract-plugin
export default {"dropDownWrapper":"activity_dropDownWrapper__WlZBt"};